module.exports = __webpack_public_path__ + "static/media/3.721b4738.jpg";